import axios from "axios";
import buildUrl from 'build-url-ts';
import { PaginatedRecords } from "src/types/common";
import { UsersStatus } from "src/types/settings/userManagement";
import { User } from "src/types/users";

const BASE_URL = process.env.REACT_APP_API_URL;
const userApiUrl = `${BASE_URL}/api/2.0/users/user_management`;
const usersApiUrl = `${BASE_URL}/api/2.0/users/users_management`;

export const usersApi = {

  fetchUsers: async (query: string, page: number): Promise<PaginatedRecords<User>> => {
    const url = buildUrl(`${userApiUrl}/users`, {
      queryParams: {
        query,
        page
      }
    });
    const response = await axios.get(url);
    return response.data;
  },
  
  fetchUserManagementStatus: async (): Promise<UsersStatus> => {
    const url = buildUrl(usersApiUrl);
    const response = await axios.get(url);
    return response.data;
  },

  notifyUser: async (key: string): Promise<any> => {
    const url = `${BASE_URL}/api/2.0/users/notify/${key}`;
    const response = await axios.post(url);
    return response.data;
  }
};
